const LabelColour = (props) => {
    switch(props) {
        case 'blue':
            return 'text-blue'
        case 'orange':
            return 'text-orange'
        case 'lime':
            return 'text-lime'
        case 'magenta':
            return 'text-magenta'
        case 'gold':
            return 'text-gold'
        case 'cyan':
            return 'text-cyan'
        case 'warmred':
            return 'text-warmred'
        case 'teal':
            return 'text-teal'
        default:
            return 'text-teal'
    }
}

const LabelColourLighten = (props) => {
    switch(props) {
        case 'blue':
            return 'fill-blue'
        case 'orange':
            return 'fill-lightorange'
        case 'lime':
            return 'fill-lightlime'
        case 'magenta':
            return 'fill-lightmagenta'
        case 'gold':
            return 'fill-lightgold'
        case 'cyan':
            return 'fill-lightcyan'
        case 'warmred':
            return 'fill-lightwarmred'
        case 'teal':
            return 'fill-lightteal'
        default:
            return 'fill-lightteal'
    }
}

const BackgroundColour = (props) => {
    switch(props) {
        case 'blue':
            return 'bg-blue'
        case 'orange':
            return 'bg-orange'
        case 'lime':
            return 'bg-lime'
        case 'magenta':
            return 'bg-magenta'
        case 'gold':
            return 'bg-gold'
        case 'cyan':
            return 'bg-cyan'
        case 'warmred':
            return 'bg-warmred'
        case 'teal':
            return 'bg-teal'
        default:
            return 'bg-teal'
    }
}

const ButtonColour = (props) => {
    switch(props) {
        case 'blue':
            return 'bg-blue hover:bg-darkblue'
        case 'orange':
            return 'bg-orange hover:bg-darkorange'
        case 'lime':
            return 'bg-lime hover:bg-darklime'
        case 'magenta':
            return 'bg-magenta hover:bg-darkmagenta'
        case 'gold':
            return 'bg-gold hover:bg-darkgold'
        case 'cyan':
            return 'bg-cyan hover:bg-darkcyan'
        case 'warmred':
            return 'bg-warmred hover:bg-darkwarmred'
        case 'teal':
            return 'bg-teal hover:bg-darkteal'
        default:
            return 'bg-teal hover:bg-darkteal'
    }
}

const FillColour = (props) => {
    switch(props) {
        case 'blue':
            return 'fill-blue'
        case 'orange':
            return 'fill-orange'
        case 'lime':
            return 'fill-lime'
        case 'magenta':
            return 'fill-magenta'
        case 'gold':
            return 'fill-gold'
        case 'cyan':
            return 'fill-cyan'
        case 'warmred':
            return 'fill-warmred'
        case 'teal':
            return 'fill-teal'
        default:
            return 'fill-teal'
    }
}

export {
    LabelColour,
    LabelColourLighten,
    BackgroundColour,
    ButtonColour,
    FillColour
}